function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M339.87 222.547H0V222.717H339.87V222.547Z",
  fill: "#E6E6E6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M77.3948 227.998H54.0117V228.168H77.3948V227.998Z",
  fill: "#E6E6E6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M88.8627 227.998H81.875V228.168H88.8627V227.998Z",
  fill: "#E6E6E6"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M123.339 224.661H110.179V224.831H123.339V224.661Z",
  fill: "#E6E6E6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M292.703 231.771H263.345V231.941H292.703V231.771Z",
  fill: "#E6E6E6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M303.062 231.771H298.759V231.941H303.062V231.771Z",
  fill: "#E6E6E6"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M270.774 225.802H207.096V225.972H270.774V225.802Z",
  fill: "#E6E6E6"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M161.098 192.23H29.8472C28.819 192.228 27.8335 191.819 27.1071 191.091C26.3806 190.363 25.9727 189.377 25.9727 188.349V3.84732C25.9816 2.82501 26.3935 1.84752 27.119 1.12716C27.8444 0.406796 28.8248 0.00175127 29.8472 0H161.098C162.127 0 163.115 0.408923 163.843 1.13681C164.57 1.8647 164.979 2.85192 164.979 3.88131V188.349C164.979 189.378 164.57 190.366 163.843 191.093C163.115 191.821 162.127 192.23 161.098 192.23ZM29.8472 0.135948C28.864 0.137749 27.9218 0.529561 27.2272 1.22538C26.5327 1.92121 26.1426 2.86418 26.1426 3.84732V188.349C26.1426 189.332 26.5327 190.275 27.2272 190.971C27.9218 191.667 28.864 192.059 29.8472 192.06H161.098C162.082 192.059 163.025 191.667 163.72 190.971C164.416 190.276 164.808 189.333 164.809 188.349V3.84732C164.808 2.86356 164.416 1.9206 163.72 1.22497C163.025 0.52934 162.082 0.137745 161.098 0.135948H29.8472Z",
  fill: "#E6E6E6"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M308.133 192.23H176.875C175.846 192.228 174.86 191.819 174.132 191.091C173.405 190.364 172.995 189.378 172.994 188.349V3.84732C173.004 2.82439 173.418 1.8469 174.144 1.12673C174.871 0.406558 175.852 0.00173217 176.875 0H308.133C309.154 0.0035377 310.132 0.409372 310.856 1.12954C311.58 1.84971 311.991 2.82619 312 3.84732V188.349C312 189.376 311.593 190.361 310.868 191.089C310.143 191.816 309.16 192.227 308.133 192.23ZM176.875 0.135948C175.891 0.137745 174.948 0.52934 174.253 1.22497C173.557 1.9206 173.165 2.86356 173.164 3.84732V188.349C173.165 189.333 173.557 190.276 174.253 190.971C174.948 191.667 175.891 192.059 176.875 192.06H308.133C309.116 192.059 310.059 191.667 310.755 190.971C311.451 190.276 311.842 189.333 311.844 188.349V3.84732C311.842 2.86356 311.451 1.9206 310.755 1.22497C310.059 0.52934 309.116 0.137745 308.133 0.135948H176.875Z",
  fill: "#E6E6E6"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M284.824 129.905H237.195V222.547H284.824V129.905Z",
  fill: "#F5F5F5"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M284.824 129.905H280.896V222.547H284.824V129.905Z",
  fill: "#F0F0F0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M131.203 152.561H240.866V132.549H131.203V152.561Z",
  fill: "#E0E0E0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M176.929 222.615H129.912C129.731 222.615 129.558 222.543 129.431 222.416C129.304 222.288 129.232 222.115 129.232 221.935C129.232 221.755 129.304 221.582 129.431 221.454C129.558 221.327 129.731 221.255 129.912 221.255H176.929C183.727 221.255 184.631 219.27 184.631 211.399V112.157C184.631 111.977 184.702 111.804 184.83 111.676C184.957 111.549 185.13 111.477 185.31 111.477C185.491 111.477 185.664 111.549 185.791 111.676C185.919 111.804 185.99 111.977 185.99 112.157V211.399C185.99 219.814 184.685 222.615 176.929 222.615Z",
  fill: "#E0E0E0"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M135.418 137.212L283.75 137.212V130.265L135.418 130.265V137.212Z",
  fill: "#F0F0F0"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M136.492 129.905H88.8623V222.547H136.492V129.905Z",
  fill: "#F5F5F5"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M136.485 129.905H132.556V222.547H136.485V129.905Z",
  fill: "#F0F0F0"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M102.763 222.547L102.763 57.574H61.89L61.89 222.547H102.763Z",
  fill: "#FAFAFA"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M100.52 98.7798V62.3933H64.1336V98.7798H100.52Z",
  fill: "#F5F5F5"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M74.2686 61.9038H90.4056C90.4056 62.9044 90.0081 63.8639 89.3006 64.5714C88.5931 65.2789 87.6336 65.6764 86.633 65.6764H78.0683C77.5706 65.6799 77.0771 65.585 76.6163 65.397C76.1554 65.209 75.7363 64.9317 75.3831 64.5811C75.0299 64.2304 74.7496 63.8133 74.5583 63.3538C74.367 62.8943 74.2685 62.4015 74.2686 61.9038Z",
  fill: "#E0E0E0"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M100.513 138.429V102.042H64.1262V138.429H100.513Z",
  fill: "#F5F5F5"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M100.52 178.078V141.692H64.1336V178.078H100.52Z",
  fill: "#F5F5F5"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M100.52 217.734V181.348H64.1336V217.734H100.52Z",
  fill: "#F5F5F5"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M74.2686 101.56H90.4056C90.4038 102.56 90.0057 103.518 89.2986 104.225C88.5915 104.933 87.633 105.331 86.633 105.332H78.0683C77.5708 105.335 77.0778 105.239 76.6173 105.051C76.1569 104.863 75.7381 104.586 75.3851 104.235C75.0321 103.885 74.7517 103.468 74.5601 103.009C74.3685 102.55 74.2694 102.057 74.2686 101.56Z",
  fill: "#E0E0E0"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M74.2686 141.209H90.4056C90.4056 142.21 90.0081 143.169 89.3006 143.877C88.5931 144.584 87.6336 144.982 86.633 144.982H78.0683C77.5706 144.985 77.0771 144.89 76.6163 144.702C76.1554 144.514 75.7363 144.237 75.3831 143.886C75.0299 143.536 74.7496 143.118 74.5583 142.659C74.367 142.2 74.2685 141.707 74.2686 141.209Z",
  fill: "#E0E0E0"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M74.2686 180.858H90.4056C90.4056 181.859 90.0081 182.819 89.3006 183.526C88.5931 184.233 87.6336 184.631 86.633 184.631H78.0683C77.5706 184.635 77.0771 184.54 76.6163 184.352C76.1554 184.164 75.7363 183.886 75.3831 183.536C75.0299 183.185 74.7496 182.768 74.5583 182.308C74.367 181.849 74.2685 181.356 74.2686 180.858Z",
  fill: "#E0E0E0"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M61.8896 222.547L61.8896 57.574H41.4771L41.4771 222.547H61.8896Z",
  fill: "#F0F0F0"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M179.717 129.905H169.446L171.94 109.907H182.218L179.717 129.905Z",
  fill: "#F0F0F0"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M181.993 129.905H171.715L174.217 109.907H184.488L181.993 129.905Z",
  fill: "#F5F5F5"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M204.03 129.905H196.601L195.18 127.641H202.603L204.03 129.905Z",
  fill: "#F0F0F0"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M243.836 129.905H198.871L197.451 127.641H237.773L243.836 129.905Z",
  fill: "#FAFAFA"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M147.136 124.168H150.385C151.907 124.168 153.366 124.772 154.442 125.848C155.518 126.924 156.122 128.383 156.122 129.905H141.386C141.386 129.15 141.535 128.403 141.824 127.706C142.113 127.009 142.537 126.376 143.071 125.843C143.605 125.311 144.239 124.888 144.937 124.601C145.634 124.313 146.382 124.166 147.136 124.168Z",
  fill: "#F0F0F0"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M183.237 119.906H172.966L174.217 109.907H184.488L183.237 119.906Z",
  fill: "#F0F0F0"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M145.464 117.513H218.196C218.34 117.513 218.481 117.483 218.612 117.424C218.742 117.365 218.858 117.279 218.953 117.172C219.048 117.065 219.118 116.938 219.16 116.801C219.202 116.664 219.214 116.52 219.196 116.378L213.595 71.5697C213.565 71.3258 213.447 71.1012 213.262 70.9384C213.078 70.7757 212.841 70.6859 212.595 70.686H139.884C139.741 70.6859 139.6 70.7161 139.47 70.7746C139.34 70.833 139.224 70.9184 139.13 71.0251C139.035 71.1318 138.965 71.2573 138.922 71.3934C138.88 71.5295 138.867 71.673 138.884 71.8144L144.485 116.63C144.515 116.87 144.63 117.092 144.81 117.254C144.99 117.417 145.222 117.509 145.464 117.513Z",
  fill: "#F0F0F0"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M146.565 117.513H219.25C219.393 117.513 219.534 117.483 219.665 117.424C219.795 117.365 219.912 117.279 220.006 117.172C220.101 117.065 220.172 116.938 220.213 116.801C220.255 116.664 220.267 116.52 220.249 116.378L214.648 71.5697C214.617 71.3264 214.498 71.1027 214.314 70.9401C214.131 70.7776 213.894 70.6873 213.649 70.686H140.964C140.822 70.6859 140.681 70.7161 140.551 70.7746C140.421 70.833 140.305 70.9184 140.21 71.0251C140.116 71.1318 140.045 71.2573 140.003 71.3934C139.961 71.5295 139.948 71.673 139.965 71.8144L145.566 116.63C145.596 116.874 145.714 117.098 145.898 117.261C146.082 117.424 146.32 117.513 146.565 117.513Z",
  fill: "#F5F5F5"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M217.904 115.032L212.663 73.0923C212.653 73.0239 212.619 72.9613 212.566 72.9163C212.514 72.8713 212.447 72.8469 212.378 72.8476H142.589C142.549 72.8461 142.509 72.8535 142.472 72.8692C142.436 72.8849 142.403 72.9085 142.376 72.9384C142.349 72.9683 142.33 73.0036 142.318 73.042C142.307 73.0803 142.304 73.1207 142.31 73.1603L147.551 115.107C147.559 115.175 147.592 115.237 147.644 115.282C147.695 115.328 147.761 115.352 147.83 115.352H217.625C217.665 115.351 217.705 115.342 217.741 115.325C217.777 115.308 217.809 115.284 217.836 115.254C217.862 115.224 217.882 115.189 217.893 115.15C217.905 115.112 217.909 115.072 217.904 115.032Z",
  fill: "#E0E0E0"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M191.34 129.905H174.605V129.694C174.605 129.253 174.78 128.829 175.092 128.517C175.405 128.204 175.828 128.029 176.27 128.029H189.674C190.116 128.029 190.54 128.204 190.852 128.517C191.164 128.829 191.34 129.253 191.34 129.694V129.905Z",
  fill: "#FAFAFA"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M176.555 129.905H165.204V129.694C165.204 129.253 165.379 128.829 165.691 128.517C166.004 128.204 166.427 128.029 166.869 128.029H174.89C175.331 128.029 175.755 128.204 176.067 128.517C176.38 128.829 176.555 129.253 176.555 129.694V129.905Z",
  fill: "#F0F0F0"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M79.1624 38.9424V38.9084C79.3187 38.385 79.4683 37.8548 79.5974 37.3246C79.8275 37.6911 80.1406 37.9983 80.5114 38.2215C80.8822 38.4446 81.3002 38.5775 81.7318 38.6093H81.9153C83.0505 38.5005 84.1381 37.3993 84.8246 35.666C84.8379 35.6348 84.8447 35.6013 84.8447 35.5674C84.8447 35.5336 84.8379 35.5 84.8246 35.4689C84.7917 35.4068 84.7354 35.3604 84.6683 35.3397C83.8535 35.1332 83.0043 35.1009 82.1762 35.245C81.3481 35.3891 80.5597 35.7063 79.8625 36.1758C79.9645 35.6728 80.0528 35.163 80.1276 34.66C80.3068 34.6946 80.4889 34.7128 80.6714 34.7144C82.5203 34.7144 83.8798 33.0626 83.9477 32.981C83.9717 32.9511 83.9882 32.9159 83.9961 32.8784C84.004 32.8408 84.0029 32.802 83.993 32.7649C83.983 32.7279 83.9645 32.6937 83.939 32.6651C83.9134 32.6365 83.8815 32.6144 83.8458 32.6004C83.4163 32.3872 82.9465 32.2672 82.4673 32.2485C81.9882 32.2297 81.5105 32.3126 81.0656 32.4916C80.5908 32.7331 80.2069 33.1218 79.9713 33.5996C79.6249 32.5359 78.9917 31.5885 78.1413 30.8617C77.291 30.1349 76.2565 29.6569 75.1519 29.4804C75.1176 29.4723 75.0819 29.4724 75.0477 29.4806C75.0134 29.4889 74.9816 29.5051 74.9548 29.528C74.9263 29.548 74.9028 29.5744 74.8863 29.6051C74.8698 29.6358 74.8607 29.6699 74.8596 29.7047C74.7645 31.3836 74.8188 33.4433 76.0764 34.4221C76.6024 34.81 77.2451 35.0066 77.8981 34.9795C78.483 34.9654 79.0636 34.874 79.6246 34.7076C79.445 35.9224 79.1839 37.1237 78.8429 38.3034C77.6127 36.6272 75.8675 35.4001 73.874 34.8095C73.811 34.7949 73.7447 34.8051 73.689 34.838C73.6333 34.8709 73.5925 34.924 73.5749 34.9863C73.1943 36.4341 73.3914 37.6101 74.1391 38.385C74.5193 38.7266 74.9645 38.9881 75.448 39.1539C75.9314 39.3197 76.4434 39.3865 76.9532 39.3502C77.5012 39.3467 78.0476 39.2898 78.5846 39.1803C78.2719 40.1727 77.9049 41.1447 77.5582 42.0692C76.8037 41.3894 74.5809 39.7037 72.1611 40.4106C72.0961 40.4321 72.0423 40.4786 72.0115 40.5397C71.9982 40.5709 71.9914 40.6044 71.9914 40.6383C71.9914 40.6722 71.9982 40.7057 72.0115 40.7369C72.6913 42.341 73.4186 43.2315 74.3566 43.5374C74.6066 43.6198 74.8683 43.6611 75.1315 43.6597C75.8498 43.6292 76.5498 43.4239 77.1707 43.0616C76.6541 44.2919 76.1035 45.4407 75.5801 46.4603C74.9589 45.8267 74.1784 45.3724 73.3207 45.1451C72.463 44.9178 71.5599 44.926 70.7064 45.1688C70.6482 45.1803 70.5964 45.2132 70.5612 45.261C70.5259 45.3088 70.5099 45.368 70.5161 45.4271C70.5762 45.9411 70.7706 46.4303 71.0796 46.8456C71.3886 47.2608 71.8014 47.5874 72.2766 47.7926C72.6351 47.9467 73.0215 48.0254 73.4118 48.0237C73.9532 48.0169 74.4849 47.8793 74.9616 47.6226C74.4314 48.6082 73.942 49.4307 73.5613 50.0561H68.9391C68.205 48.7986 67.3553 47.2352 66.526 45.4814C66.9123 45.5968 67.3125 45.6585 67.7156 45.665C68.2113 45.6711 68.7017 45.5631 69.1489 45.3492C69.5961 45.1352 69.988 44.8212 70.2943 44.4314C70.6006 44.0417 70.8131 43.5866 70.9152 43.1015C71.0173 42.6164 71.0063 42.1143 70.8831 41.6341C70.8673 41.5784 70.8315 41.5303 70.7827 41.499C70.7339 41.4677 70.6754 41.4553 70.618 41.4642C69.6741 41.5562 68.7662 41.8742 67.9712 42.3913C67.1761 42.9083 66.5172 43.6092 66.0502 44.4346C65.5064 43.2111 64.9762 41.9128 64.514 40.5737C65.1023 40.9085 65.7615 41.0995 66.4376 41.1311C66.706 41.1342 66.9728 41.0905 67.2261 41.002C68.5856 40.5533 69.3673 38.9152 70.0335 37.2158C70.0485 37.1851 70.0563 37.1514 70.0563 37.1173C70.0563 37.0831 70.0485 37.0494 70.0335 37.0187C70.0178 36.9875 69.9958 36.9599 69.9689 36.9377C69.942 36.9154 69.9107 36.899 69.8771 36.8895C67.1582 36.1282 64.9218 38.7452 64.2285 39.6833C63.8659 38.5514 63.5642 37.401 63.3244 36.237C63.8956 36.3488 64.4758 36.4079 65.0578 36.4137C65.6361 36.456 66.217 36.3789 66.7643 36.1871C67.3115 35.9953 67.8135 35.693 68.239 35.299C69.0614 34.4289 69.2586 33.1238 68.8167 31.5332C68.8089 31.502 68.7948 31.4727 68.7754 31.4471C68.7559 31.4216 68.7315 31.4002 68.7035 31.3843C68.6756 31.3684 68.6447 31.3584 68.6127 31.3547C68.5808 31.3511 68.5484 31.354 68.5177 31.3633C66.3485 32.0402 64.4602 33.408 63.1409 35.2582L63.039 34.6396C63.0318 34.5861 63.008 34.5362 62.971 34.4969C62.8589 34.0947 62.6636 33.7205 62.3978 33.3985C62.132 33.0765 61.8016 32.8139 61.428 32.6276C60.9376 32.4384 60.4127 32.3551 59.8879 32.3832C59.363 32.4113 58.8501 32.5502 58.3827 32.7907C58.3468 32.8062 58.3148 32.8295 58.2889 32.8589C58.2631 32.8883 58.244 32.923 58.2332 32.9606C58.2248 32.9976 58.2254 33.0359 58.2349 33.0726C58.2443 33.1092 58.2624 33.1431 58.2876 33.1714C58.3555 33.2597 59.851 35.0271 61.863 35.0271C62.0799 35.0243 62.296 35.0015 62.5088 34.9591C62.5971 35.5369 62.7059 36.1146 62.8282 36.6856C62.0531 36.1753 61.1785 35.8351 60.2623 35.6875C59.346 35.5399 58.4089 35.5882 57.5127 35.8291C57.4455 35.8498 57.3893 35.8962 57.3563 35.9583C57.3429 35.9906 57.3359 36.0253 57.3359 36.0603C57.3359 36.0953 57.3429 36.1299 57.3563 36.1622C58.138 38.0519 59.348 39.2482 60.5987 39.3502H60.7686C61.4008 39.3502 62.2573 39.0579 63.1273 37.8956C63.4699 39.2172 63.8829 40.5196 64.3644 41.7973C63.1885 41.2399 60.5443 40.2814 58.6546 41.7429C58.6287 41.7617 58.6067 41.7855 58.5902 41.813C58.5737 41.8404 58.5629 41.8709 58.5584 41.9027C58.554 41.9344 58.556 41.9667 58.5644 41.9977C58.5727 42.0286 58.5872 42.0576 58.6071 42.0828C59.8306 43.7481 60.9589 44.557 62.0669 44.557C62.9846 44.557 63.8614 43.9792 64.7383 42.8373C65.2413 44.088 65.7851 45.2843 66.3221 46.3855C65.1461 45.6582 63.8546 45.7737 62.332 46.7322C62.2968 46.7533 62.2676 46.7832 62.2474 46.8189C62.2271 46.8546 62.2165 46.895 62.2165 46.9361C62.2137 46.9761 62.2217 47.0161 62.2396 47.052C62.2575 47.0878 62.2848 47.1182 62.3184 47.14C63.2253 47.7937 64.2962 48.182 65.4112 48.2616C65.9865 48.273 66.5505 48.1016 67.0222 47.7722C67.4573 48.6082 67.8855 49.3763 68.2797 50.0629H66.1793V51.2592H66.9407L67.5728 57.5944H76.8784L77.5038 51.2592H78.2719V50.0629H74.0915C74.5537 49.2948 75.1451 48.2684 75.7773 47.0652C75.7961 47.041 75.81 47.0133 75.8181 46.9837C75.9812 46.6778 76.1375 46.3651 76.3007 46.0388C76.5771 46.4571 76.9497 46.8031 77.3873 47.0479C77.8248 47.2927 78.3146 47.4292 78.8157 47.4459C78.9198 47.4527 79.0243 47.4527 79.1284 47.4459C79.6821 47.3831 80.2077 47.1683 80.6468 46.8251C81.0859 46.482 81.4215 46.024 81.6162 45.5018C81.6363 45.4482 81.6364 45.3891 81.6164 45.3354C81.5964 45.2817 81.5578 45.237 81.5075 45.2096C80.7947 44.8069 79.9965 44.5797 79.1785 44.5466C78.3606 44.5135 77.5466 44.6755 76.8037 45.0192C77.1571 44.2783 77.4834 43.483 77.8369 42.6605C77.8635 42.63 77.8802 42.592 77.8845 42.5518C77.9796 42.3207 78.068 42.0895 78.1632 41.872C78.972 42.8916 79.7741 43.3946 80.6102 43.3946C81.623 43.3946 82.6494 42.6469 83.7506 41.1039C83.7888 41.0524 83.8053 40.9878 83.7964 40.9243C83.7875 40.8607 83.754 40.8031 83.703 40.7641C81.9697 39.4658 79.6246 40.3562 78.5234 40.8728C78.7477 40.261 78.9517 39.6425 79.142 39.0103L79.1624 38.9424Z",
  fill: "#E0E0E0"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M273.575 36.0737H238.813V74.2411H273.575V36.0737Z",
  fill: "#E0E0E0"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M269.286 37.6371C269.257 37.644 269.226 37.644 269.197 37.6371C269.116 37.5827 260.904 32.7022 258.321 32.7022C255.738 32.7022 247.887 37.5827 247.806 37.6303C247.787 37.6425 247.766 37.6509 247.744 37.6548C247.723 37.6587 247.7 37.6581 247.679 37.653C247.657 37.6479 247.636 37.6384 247.619 37.6252C247.601 37.6119 247.586 37.5951 247.575 37.5759C247.552 37.5379 247.545 37.4925 247.555 37.4493C247.565 37.4061 247.592 37.3686 247.629 37.3448C247.955 37.1409 255.616 32.3623 258.321 32.3623C261.027 32.3623 269.061 37.1205 269.401 37.3448C269.42 37.3559 269.437 37.3709 269.45 37.3887C269.464 37.4066 269.473 37.427 269.478 37.4486C269.483 37.4703 269.484 37.4927 269.48 37.5146C269.476 37.5365 269.468 37.5574 269.455 37.5759C269.436 37.6017 269.41 37.6213 269.38 37.6322C269.35 37.643 269.317 37.6448 269.286 37.6371Z",
  fill: "#EBEBEB"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M277.334 36.0737H241.43V74.2411H277.334V36.0737Z",
  fill: "#F5F5F5"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M274.329 71.2298V39.0781H244.441V71.2298H274.329Z",
  fill: "white"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M265.174 60.9464C268.373 57.7476 268.373 52.5615 265.174 49.3627C261.975 46.164 256.789 46.164 253.59 49.3627C250.391 52.5615 250.391 57.7476 253.59 60.9464C256.789 64.1451 261.975 64.1451 265.174 60.9464Z",
  fill: "#E0E0E0"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M258.688 176.222H289.154C291.95 176.225 294.635 175.13 296.631 173.174C298.628 171.218 299.778 168.556 299.833 165.761L300.975 109.982C300.996 108.947 300.81 107.918 300.428 106.955C300.046 105.993 299.476 105.116 298.751 104.377C298.027 103.638 297.162 103.05 296.207 102.65C295.252 102.249 294.227 102.042 293.192 102.042H274.091C272.18 102.042 270.336 102.745 268.911 104.018C267.485 105.29 266.578 107.043 266.363 108.942L258.688 176.222Z",
  fill: "#E6E6E6"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M275.315 176.222H242.851C242.447 176.222 242.059 176.062 241.774 175.776C241.488 175.491 241.328 175.104 241.328 174.7V174.557C241.328 173.45 241.768 172.389 242.55 171.606C243.333 170.823 244.395 170.383 245.502 170.383H275.315V176.222Z",
  fill: "#E6E6E6"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M272.752 223.308C272.594 223.311 272.44 223.26 272.316 223.162C272.192 223.064 272.106 222.926 272.073 222.771L262.556 176.902H245.971L236.454 222.771C236.417 222.951 236.31 223.109 236.157 223.211C236.003 223.312 235.815 223.348 235.635 223.311C235.455 223.274 235.297 223.167 235.195 223.014C235.094 222.86 235.058 222.672 235.095 222.492L244.733 176.086C244.765 175.931 244.851 175.791 244.975 175.691C245.099 175.592 245.254 175.539 245.413 175.543H263.086C263.245 175.539 263.401 175.592 263.525 175.691C263.649 175.791 263.734 175.931 263.766 176.086L273.398 222.492C273.434 222.668 273.4 222.851 273.302 223.001C273.204 223.151 273.05 223.257 272.875 223.294C272.835 223.304 272.793 223.308 272.752 223.308Z",
  fill: "#E6E6E6"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M262.413 223.308C262.368 223.315 262.322 223.315 262.277 223.308C262.19 223.29 262.107 223.255 262.033 223.205C261.959 223.155 261.895 223.091 261.846 223.017C261.797 222.942 261.763 222.859 261.746 222.771C261.729 222.684 261.729 222.593 261.747 222.506L271.386 176.1C271.418 175.944 271.503 175.804 271.627 175.705C271.751 175.606 271.907 175.553 272.066 175.556H289.739C289.898 175.553 290.053 175.606 290.177 175.705C290.301 175.804 290.387 175.944 290.419 176.1L300.05 222.506C300.069 222.595 300.069 222.687 300.052 222.777C300.035 222.866 300 222.951 299.95 223.027C299.9 223.103 299.835 223.169 299.76 223.22C299.684 223.271 299.599 223.307 299.51 223.325C299.421 223.343 299.329 223.344 299.239 223.327C299.15 223.309 299.065 223.275 298.989 223.224C298.913 223.174 298.847 223.11 298.796 223.034C298.745 222.959 298.709 222.874 298.691 222.785L289.175 176.916H272.575L263.059 222.785C263.024 222.931 262.942 223.062 262.825 223.156C262.709 223.251 262.564 223.304 262.413 223.308Z",
  fill: "#E6E6E6"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M175.7 252.195C248.488 252.195 307.495 248.75 307.495 244.501C307.495 240.251 248.488 236.806 175.7 236.806C102.912 236.806 43.9053 240.251 43.9053 244.501C43.9053 248.75 102.912 252.195 175.7 252.195Z",
  fill: "#F5F5F5"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M187.33 238.22C187.117 238.219 186.911 238.145 186.746 238.01C186.582 237.875 186.469 237.688 186.426 237.479L173.511 173.883H151.019L138.104 237.479C138.042 237.706 137.897 237.9 137.697 238.023C137.497 238.147 137.258 238.189 137.028 238.143C136.798 238.096 136.594 237.963 136.458 237.772C136.322 237.581 136.264 237.345 136.296 237.112L149.36 172.775C149.404 172.566 149.517 172.379 149.681 172.245C149.846 172.11 150.052 172.035 150.264 172.034H174.259C174.472 172.034 174.678 172.108 174.843 172.243C175.008 172.378 175.121 172.566 175.163 172.775L188.234 237.112C188.283 237.352 188.234 237.601 188.099 237.805C187.964 238.008 187.753 238.15 187.514 238.2L187.33 238.22Z",
  fill: "#407BFF"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M151.23 238.22C151.017 238.218 150.811 238.144 150.647 238.009C150.483 237.874 150.369 237.687 150.326 237.479L137.411 173.883H114.918L102.003 237.479C101.986 237.604 101.943 237.725 101.878 237.833C101.812 237.941 101.725 238.035 101.622 238.108C101.519 238.181 101.402 238.232 101.279 238.259C101.155 238.285 101.027 238.285 100.903 238.26C100.779 238.235 100.662 238.185 100.558 238.112C100.454 238.04 100.367 237.947 100.3 237.84C100.234 237.732 100.19 237.612 100.172 237.487C100.154 237.361 100.162 237.234 100.195 237.112L113.266 172.775C113.309 172.566 113.422 172.378 113.586 172.243C113.751 172.108 113.957 172.034 114.17 172.034H138.165C138.377 172.034 138.583 172.109 138.746 172.244C138.91 172.379 139.022 172.566 139.062 172.775L152.134 237.112C152.182 237.352 152.133 237.601 151.998 237.805C151.863 238.008 151.653 238.15 151.413 238.2L151.23 238.22Z",
  fill: "#407BFF"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M156.28 172.965H114.952C111.158 172.966 107.516 171.479 104.806 168.824C102.097 166.169 100.536 162.558 100.46 158.765L98.9236 95.9575C98.8947 94.5536 99.1461 93.158 99.6633 91.8525C100.18 90.5469 100.953 89.3577 101.935 88.3544C102.918 87.3511 104.09 86.5539 105.385 86.0094C106.679 85.465 108.069 85.1842 109.473 85.1836H135.385C137.978 85.1853 140.48 86.1408 142.414 87.8681C144.348 89.5954 145.58 91.9739 145.873 94.5504L156.28 172.965Z",
  fill: "#407BFF"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M133.74 165.012H174.184C175.686 165.012 177.126 165.609 178.188 166.671C179.25 167.733 179.846 169.173 179.846 170.674V170.872C179.846 171.412 179.632 171.931 179.249 172.314C178.867 172.696 178.348 172.911 177.807 172.911H133.74V165.012Z",
  fill: "#407BFF"
});

var _ref54 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M187.331 238.22C187.118 238.22 186.912 238.146 186.747 238.011C186.582 237.876 186.469 237.688 186.427 237.479L173.512 173.883H151.019L138.104 237.479C138.043 237.706 137.897 237.9 137.697 238.024C137.497 238.147 137.258 238.19 137.028 238.143C136.798 238.096 136.594 237.964 136.458 237.772C136.322 237.581 136.264 237.345 136.296 237.112L149.361 172.775C149.404 172.567 149.517 172.38 149.682 172.245C149.846 172.11 150.052 172.036 150.265 172.034H174.259C174.472 172.034 174.679 172.108 174.843 172.243C175.008 172.378 175.121 172.566 175.164 172.775L188.235 237.112C188.283 237.352 188.234 237.601 188.099 237.805C187.964 238.009 187.754 238.151 187.514 238.2L187.331 238.22Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M151.23 238.22C151.017 238.218 150.811 238.144 150.647 238.009C150.483 237.874 150.369 237.687 150.326 237.479L137.411 173.883H114.918L102.003 237.479C101.986 237.605 101.943 237.725 101.878 237.833C101.812 237.941 101.725 238.035 101.622 238.108C101.519 238.181 101.402 238.233 101.279 238.259C101.155 238.285 101.027 238.286 100.903 238.26C100.779 238.235 100.662 238.185 100.558 238.113C100.454 238.04 100.367 237.947 100.3 237.84C100.234 237.732 100.19 237.612 100.172 237.487C100.154 237.362 100.162 237.234 100.195 237.112L113.266 172.775C113.309 172.566 113.422 172.378 113.586 172.243C113.751 172.108 113.957 172.034 114.17 172.034H138.165C138.377 172.035 138.583 172.109 138.746 172.244C138.91 172.379 139.022 172.567 139.062 172.775L152.134 237.112C152.182 237.352 152.133 237.601 151.998 237.805C151.863 238.009 151.653 238.151 151.413 238.2L151.23 238.22Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M156.28 172.965H114.952C111.158 172.966 107.516 171.479 104.806 168.824C102.097 166.169 100.536 162.558 100.46 158.765L98.9236 95.9575C98.8947 94.5536 99.1461 93.158 99.6633 91.8525C100.18 90.5469 100.953 89.3577 101.935 88.3544C102.918 87.3511 104.09 86.5539 105.385 86.0094C106.679 85.465 108.069 85.1842 109.473 85.1836H135.385C137.978 85.1853 140.48 86.1408 142.414 87.8681C144.348 89.5954 145.58 91.9739 145.873 94.5504L156.28 172.965Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M133.74 165.012H174.185C175.686 165.012 177.127 165.609 178.189 166.671C179.25 167.733 179.847 169.173 179.847 170.674V170.872C179.847 171.412 179.632 171.931 179.25 172.314C178.867 172.696 178.349 172.911 177.808 172.911H133.74V165.012Z",
  fill: "black"
}));

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M144.779 81.7169C144.779 81.7169 150.557 89.262 146.818 104.284C143.08 119.306 123.789 111.15 122.619 97.6092C121.26 81.6489 139.178 92.6539 142.332 78.4609L144.779 81.7169Z",
  fill: "#263238"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M140.585 77.2373C138.076 79.0046 137.084 81.574 139.857 84.0891C142.631 86.6041 146.587 86.5225 147.783 85.4893C148.979 84.4561 148.741 79.2086 148.741 79.2086L140.585 77.2373Z",
  fill: "#407BFF"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M140.585 77.2373C138.076 79.0046 137.084 81.574 139.857 84.0891C142.631 86.6041 146.587 86.5225 147.783 85.4893C148.979 84.4561 148.741 79.2086 148.741 79.2086L140.585 77.2373Z",
  fill: "white"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M172.261 110.674C172.329 110.98 172.444 111.456 172.553 111.857L172.879 113.134C173.11 113.991 173.362 114.847 173.627 115.704C174.13 117.43 174.687 119.15 175.272 120.87C175.856 122.59 176.455 124.269 177.107 126.009C177.427 126.858 177.746 127.715 178.086 128.565L178.48 129.584C178.559 129.759 178.662 129.921 178.786 130.067C179.754 131.045 180.933 131.79 182.232 132.242C183.82 132.881 185.457 133.39 187.127 133.765C188.853 134.166 190.627 134.499 192.422 134.777C194.216 135.056 196.058 135.28 197.826 135.457L197.887 139.114C194.009 139.515 190.1 139.515 186.223 139.114C184.196 138.905 182.192 138.516 180.234 137.952C179.174 137.632 178.141 137.225 177.148 136.735C176.004 136.179 174.957 135.442 174.048 134.553C173.521 134.028 173.064 133.436 172.689 132.793C172.587 132.629 172.499 132.446 172.403 132.276L172.227 131.909L171.914 131.229C171.493 130.366 171.071 129.503 170.684 128.626C169.895 126.872 169.127 125.105 168.441 123.303C167.754 121.502 167.081 119.687 166.51 117.865C166.231 116.927 165.959 115.996 165.708 115.038L165.334 113.604C165.225 113.087 165.123 112.659 165.015 112.047L172.261 110.674Z",
  fill: "#E58A7B"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M169.95 102.952C172.866 103.693 174.898 115.683 174.898 115.683L166.87 121.121C166.87 121.121 159.169 109.022 161.433 105.82C163.75 102.53 165.695 101.891 169.95 102.952Z",
  fill: "#407BFF"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M169.95 102.952C172.866 103.693 174.898 115.683 174.898 115.683L166.87 121.121C166.87 121.121 159.169 109.022 161.433 105.82C163.75 102.53 165.695 101.891 169.95 102.952Z",
  fill: "white"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M168.903 105.97L161.922 111.503C163.282 114.864 164.936 118.099 166.864 121.169L172.431 117.383L168.903 105.97Z",
  fill: "#407BFF"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M169.95 102.952C169.95 102.952 173.349 104.135 166.551 145.619H137.853C138.335 133.934 138.349 126.729 132.768 102.741C136.787 101.913 140.86 101.377 144.956 101.137C149.298 100.827 153.657 100.827 158 101.137C163.601 101.674 169.95 102.952 169.95 102.952Z",
  fill: "#407BFF"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M169.95 102.952C169.95 102.952 173.349 104.135 166.551 145.619H137.853C138.335 133.934 138.349 126.729 132.768 102.741C136.787 101.913 140.86 101.377 144.956 101.137C149.298 100.827 153.657 100.827 158 101.137C163.601 101.674 169.95 102.952 169.95 102.952Z",
  fill: "white"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M196.772 135.423L201.782 130.339L202.462 137.503C202.462 137.503 198.703 140.045 196.106 138.679L196.772 135.423Z",
  fill: "#E58A7B"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M207.696 129.584L207.92 135.606L202.455 137.503L201.795 130.338L207.696 129.584Z",
  fill: "#E58A7B"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M199.124 231.627H206.193L207.281 215.252H200.212L199.124 231.627Z",
  fill: "#E58A7B"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M171.764 231.627H178.833L181.104 215.252H174.034L171.764 231.627Z",
  fill: "#E58A7B"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M179.276 230.804H171.33C171.193 230.801 171.059 230.849 170.955 230.938C170.851 231.027 170.784 231.151 170.765 231.287L169.861 237.574C169.845 237.733 169.862 237.894 169.912 238.045C169.962 238.197 170.043 238.337 170.15 238.455C170.257 238.574 170.387 238.668 170.533 238.733C170.679 238.798 170.837 238.832 170.996 238.832C173.763 238.784 175.075 238.621 178.589 238.621C180.737 238.621 186.25 238.845 189.22 238.845C192.191 238.845 192.347 235.909 191.11 235.644C185.57 234.447 182.321 232.809 180.452 231.239C180.124 230.959 179.707 230.805 179.276 230.804Z",
  fill: "#263238"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M206.744 230.804H198.812C198.675 230.803 198.543 230.851 198.439 230.939C198.335 231.028 198.267 231.152 198.247 231.287L197.343 237.574C197.327 237.733 197.344 237.893 197.394 238.045C197.444 238.197 197.525 238.336 197.632 238.455C197.739 238.573 197.869 238.668 198.015 238.733C198.161 238.798 198.319 238.832 198.478 238.832C201.245 238.784 202.557 238.621 206.071 238.621C208.226 238.621 212.665 238.845 215.635 238.845C218.606 238.845 218.762 235.909 217.525 235.644C211.985 234.447 209.803 232.809 207.94 231.239C207.606 230.956 207.182 230.802 206.744 230.804Z",
  fill: "#263238"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M164.315 72.1733C166.857 72.3365 168.148 85.0884 160.692 84.3475C153.235 83.6066 164.315 72.1733 164.315 72.1733Z",
  fill: "#263238"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M207.281 215.252L206.717 223.694H199.647L200.205 215.252H207.281Z",
  fill: "#CF6F64"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M174.035 215.252H181.111L179.935 223.694H172.859L174.035 215.252Z",
  fill: "#CF6F64"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M135.636 116.078C136.316 119.558 136.799 122.562 137.166 125.268L138.845 112.278L135.636 116.078Z",
  fill: "#407BFF"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M146.247 86.4819C147.07 90.6759 147.892 98.3638 144.956 101.164C144.956 101.164 146.104 105.419 153.901 105.419C162.472 105.419 157.979 101.164 157.979 101.164C153.296 100.05 153.418 96.5761 154.234 93.3201L146.247 86.4819Z",
  fill: "#E58A7B"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M152.351 106.33L154.961 105.392L154.615 104.678L152.351 106.33Z",
  fill: "#263238"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M157.415 105.786L154.961 105.392L155.492 104.597L157.415 105.786Z",
  fill: "#263238"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M145.907 99.1862L144.133 100.913C144.08 100.967 144.05 101.041 144.05 101.117C144.05 101.193 144.08 101.266 144.133 101.321L151.61 109.838C151.966 107.815 153.049 105.992 154.656 104.713C148.47 102.374 146.859 99.9543 146.308 99.2746C146.296 99.2351 146.273 99.1996 146.242 99.1717C146.211 99.1438 146.174 99.1244 146.133 99.1154C146.093 99.1065 146.05 99.1083 146.011 99.1208C145.971 99.1332 145.935 99.1558 145.907 99.1862Z",
  fill: "#407BFF"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M156.593 100.491L158.795 101.09C158.861 101.108 158.921 101.143 158.969 101.192C159.016 101.241 159.05 101.302 159.067 101.368C159.689 104.162 159.572 107.069 158.727 109.804C158.415 108.648 157.368 105.882 155.492 104.597C157.531 103.19 156.708 101.375 156.416 100.688C156.407 100.663 156.404 100.635 156.409 100.608C156.414 100.582 156.427 100.557 156.445 100.537C156.463 100.516 156.487 100.501 156.513 100.493C156.539 100.485 156.566 100.485 156.593 100.491Z",
  fill: "#407BFF"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M149.517 89.2688L154.275 93.3133C154.077 94.0711 153.943 94.8442 153.874 95.6244C152.086 95.3661 149.632 93.4084 149.442 91.5459C149.325 90.7888 149.351 90.0166 149.517 89.2688Z",
  fill: "#CF6F64"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M145.792 75.4291C144.983 82.3964 144.487 85.3329 147.342 89.4929C151.624 95.7533 160.365 95.2231 163.241 88.6365C165.83 82.7091 166.714 72.3227 160.461 68.353C159.085 67.475 157.508 66.9632 155.879 66.8665C154.249 66.7697 152.623 67.0911 151.153 67.8002C149.683 68.5092 148.419 69.5824 147.48 70.9176C146.542 72.2529 145.961 73.8059 145.792 75.4291Z",
  fill: "#E58A7B"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M161.724 63.9213C150.203 59.3738 141.55 64.5059 139.762 71.7995C136.955 83.1239 145.921 83.9192 145.921 83.9192L147.042 81.0235C148.653 81.9955 153.16 81.5673 151.8 73.1589C150.998 68.4008 157.021 75.0282 164.661 74.2873C166.693 74.0902 169.473 66.9801 161.724 63.9213Z",
  fill: "#263238"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M165.647 66.7218C164.131 64.3903 161.031 62.3919 154.608 61.447C154.608 61.447 157.945 62.2015 159.026 64.6418C160.107 67.0821 167.475 69.5291 165.647 66.7218Z",
  fill: "#263238"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M143.576 81.4585C143.528 82.1285 143.614 82.8013 143.828 83.4381C144.041 84.075 144.378 84.6635 144.819 85.1698C146.009 86.5293 147.572 85.6932 148.062 84.0619C148.497 82.5868 148.408 80.1126 146.818 79.3649C145.227 78.6172 143.705 79.7999 143.576 81.4585Z",
  fill: "#E58A7B"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M166.571 145.646C166.571 145.646 213.976 150.058 213.514 171.612C213.031 194.044 208.232 222.063 208.232 222.063H198.437C198.437 222.063 197.601 198.353 197.316 176.268C197.173 164.767 151.365 162.463 151.365 162.463L145.452 145.646H166.571Z",
  fill: "#263238"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M158.986 145.646C158.986 145.646 189.621 155.808 190.396 168.384C191.817 191.535 181.641 222.083 181.641 222.083H171.996C171.996 222.083 172.546 201.827 173.695 180.85C175.15 154.49 128.642 180.483 137.853 145.667L158.986 145.646Z",
  fill: "#263238"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M155.872 79.229C155.77 79.7863 155.987 80.2961 156.354 80.3641C156.721 80.4321 157.095 80.0242 157.197 79.4669C157.299 78.9095 157.082 78.3929 156.715 78.3317C156.348 78.2705 155.987 78.6648 155.872 79.229Z",
  fill: "#263238"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M162.214 80.3642C162.112 80.9216 162.33 81.4314 162.697 81.4994C163.064 81.5673 163.444 81.1595 163.546 80.6021C163.648 80.0447 163.431 79.5281 163.064 79.4669C162.697 79.4058 162.316 79.8 162.214 80.3642Z",
  fill: "#263238"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M162.894 79.4669L164.315 79.3174C164.315 79.3174 163.465 80.2486 162.894 79.4669Z",
  fill: "#263238"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M160.365 81.0234C160.637 82.3932 161.095 83.7196 161.725 84.9659C161.405 85.1117 161.057 85.1871 160.705 85.1871C160.353 85.1871 160.006 85.1117 159.686 84.9659L160.365 81.0234Z",
  fill: "#DF5753"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M157.347 86.7808C156.601 86.6625 155.894 86.3701 155.282 85.9272C154.67 85.4843 154.171 84.9035 153.826 84.2318C153.815 84.2057 153.814 84.176 153.824 84.1493C153.834 84.1226 153.854 84.1009 153.88 84.0891C153.908 84.0797 153.937 84.0808 153.964 84.0921C153.99 84.1034 154.011 84.1241 154.023 84.1502C154.35 84.785 154.821 85.3345 155.398 85.7547C155.975 86.1748 156.643 86.4541 157.347 86.5701C157.375 86.5766 157.4 86.5935 157.417 86.6175C157.433 86.6414 157.44 86.6706 157.436 86.6993C157.43 86.7201 157.419 86.7389 157.404 86.7534C157.388 86.7679 157.368 86.7774 157.347 86.7808Z",
  fill: "#263238"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M154.384 76.7207C154.354 76.7218 154.325 76.7163 154.298 76.7045C154.271 76.6927 154.247 76.675 154.227 76.6527C154.207 76.6336 154.19 76.6105 154.179 76.5848C154.168 76.559 154.162 76.5313 154.162 76.5032C154.162 76.4751 154.168 76.4473 154.179 76.4216C154.19 76.3959 154.207 76.3727 154.227 76.3536C154.594 75.9959 155.04 75.7313 155.53 75.5823C156.02 75.4332 156.538 75.404 157.042 75.4972C157.095 75.513 157.14 75.5486 157.168 75.5966C157.195 75.6446 157.204 75.7015 157.191 75.7555C157.185 75.7829 157.173 75.8088 157.156 75.8315C157.14 75.8543 157.119 75.8736 157.095 75.8881C157.071 75.9027 157.044 75.9123 157.016 75.9164C156.988 75.9205 156.96 75.9189 156.933 75.9118C156.498 75.8351 156.052 75.8635 155.631 75.9948C155.21 76.1261 154.827 76.3564 154.513 76.6663C154.476 76.6974 154.431 76.7164 154.384 76.7207Z",
  fill: "#263238"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M165.681 77.8357C165.639 77.8372 165.597 77.8256 165.562 77.8024C165.527 77.7793 165.499 77.7458 165.484 77.7065C165.318 77.2985 165.058 76.9356 164.724 76.6473C164.391 76.3591 163.995 76.1537 163.567 76.0479C163.512 76.0379 163.462 76.0069 163.429 75.9612C163.396 75.9156 163.382 75.859 163.39 75.8032C163.4 75.7465 163.432 75.696 163.48 75.6628C163.527 75.6297 163.585 75.6166 163.642 75.6265C164.14 75.7419 164.603 75.9758 164.991 76.3083C165.379 76.6408 165.681 77.0622 165.871 77.5366C165.894 77.5889 165.896 77.6482 165.876 77.7016C165.855 77.755 165.815 77.7983 165.763 77.8221L165.681 77.8357Z",
  fill: "#263238"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M137.057 112.998C136.438 115.038 135.772 117.077 135.181 119.17C134.589 121.264 133.964 123.303 133.427 125.376C132.89 127.45 132.38 129.502 132 131.494C131.816 132.5 131.646 133.499 131.551 134.437C131.497 134.906 131.469 135.348 131.463 135.756C131.463 135.851 131.463 135.756 131.395 135.6C131.312 135.416 131.197 135.247 131.055 135.104C130.708 134.804 130.579 134.859 130.735 134.906C131.02 134.976 131.313 135.005 131.605 134.995C132.521 134.963 133.431 134.847 134.324 134.648C136.349 134.202 138.344 133.632 140.299 132.942C144.317 131.582 148.395 129.924 152.365 128.231L154.118 131.433C150.352 133.902 146.416 136.101 142.339 138.013C140.227 139.009 138.049 139.856 135.82 140.548C134.579 140.926 133.304 141.183 132.013 141.316C131.207 141.399 130.394 141.378 129.593 141.255C129.062 141.176 128.543 141.027 128.05 140.813C127.413 140.538 126.836 140.141 126.351 139.644C125.408 138.651 124.868 137.343 124.835 135.974C124.801 135.294 124.794 134.614 124.835 134.002C124.883 132.745 124.998 131.555 125.155 130.393C125.481 128.068 125.902 125.825 126.419 123.596C126.936 121.366 127.486 119.211 128.091 117.05C128.696 114.888 129.349 112.767 130.13 110.606L137.057 112.998Z",
  fill: "#E58A7B"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M181.695 231.994C181.069 231.978 180.446 231.891 179.839 231.735C179.817 231.731 179.796 231.72 179.78 231.704C179.763 231.687 179.752 231.666 179.748 231.644C179.743 231.621 179.746 231.598 179.755 231.576C179.764 231.555 179.779 231.537 179.799 231.525C180.037 231.368 182.157 229.995 182.966 230.355C183.051 230.394 183.124 230.455 183.177 230.531C183.229 230.608 183.26 230.698 183.265 230.79C183.299 230.941 183.293 231.098 183.248 231.246C183.203 231.394 183.12 231.527 183.007 231.633C182.626 231.904 182.161 232.032 181.695 231.994ZM180.166 231.572C181.478 231.844 182.463 231.81 182.844 231.457C182.927 231.376 182.988 231.276 183.021 231.165C183.054 231.055 183.059 230.937 183.034 230.824C183.032 230.771 183.014 230.719 182.984 230.675C182.955 230.631 182.913 230.595 182.864 230.573C182.348 230.342 180.913 231.11 180.166 231.572Z",
  fill: "#407BFF"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M179.867 231.742H179.806C179.787 231.731 179.771 231.715 179.76 231.696C179.75 231.677 179.744 231.655 179.745 231.633C179.745 231.552 179.745 229.54 180.506 228.874C180.595 228.788 180.703 228.725 180.821 228.688C180.939 228.651 181.064 228.643 181.186 228.663C181.308 228.662 181.427 228.703 181.523 228.78C181.618 228.857 181.684 228.964 181.709 229.084C181.852 229.818 180.669 231.321 179.928 231.742H179.867ZM181.063 228.874C180.914 228.875 180.77 228.933 180.662 229.037C180.125 229.513 180.017 230.858 179.983 231.395C180.662 230.906 181.573 229.669 181.458 229.118C181.458 229.03 181.39 228.914 181.145 228.88L181.063 228.874Z",
  fill: "#407BFF"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M209.402 231.994C208.655 231.977 207.911 231.893 207.179 231.742C207.155 231.736 207.133 231.723 207.116 231.705C207.099 231.687 207.088 231.665 207.084 231.64C207.08 231.615 207.085 231.59 207.097 231.568C207.109 231.546 207.129 231.528 207.152 231.518C207.464 231.355 210.258 229.927 211.108 230.39C211.182 230.43 211.244 230.489 211.289 230.56C211.334 230.632 211.361 230.713 211.366 230.797C211.385 230.939 211.369 231.083 211.319 231.217C211.27 231.351 211.188 231.471 211.081 231.565C210.586 231.896 209.994 232.047 209.402 231.994ZM207.573 231.572C208.484 231.729 210.292 231.953 210.917 231.396C210.995 231.323 211.055 231.232 211.092 231.132C211.128 231.031 211.141 230.924 211.128 230.818C211.128 230.772 211.115 230.727 211.091 230.687C211.067 230.648 211.033 230.615 210.992 230.593C210.435 230.294 208.559 231.09 207.573 231.572Z",
  fill: "#407BFF"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M207.206 231.742C207.184 231.749 207.16 231.749 207.138 231.742C207.122 231.729 207.108 231.713 207.099 231.694C207.09 231.675 207.084 231.654 207.084 231.633C207.084 231.552 207.254 229.669 208.124 228.914C208.246 228.81 208.388 228.733 208.541 228.686C208.694 228.639 208.855 228.624 209.014 228.642C209.449 228.683 209.572 228.901 209.606 229.071C209.728 229.852 208.083 231.348 207.254 231.722L207.206 231.742ZM208.885 228.874C208.662 228.873 208.446 228.955 208.28 229.105C207.641 229.635 207.417 230.906 207.349 231.416C208.24 230.92 209.456 229.642 209.388 229.118C209.388 229.064 209.388 228.914 209.014 228.88L208.885 228.874Z",
  fill: "#407BFF"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M152.202 128.34L158.904 126.641L155.709 133.078C155.709 133.078 151.176 133.275 149.68 130.746L152.202 128.34Z",
  fill: "#E58A7B"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M164.321 129.081L161.358 134.329L155.709 133.078L158.904 126.641L164.321 129.081Z",
  fill: "#E58A7B"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M156.545 78.3317L157.966 78.1821C157.966 78.1821 157.089 79.1134 156.545 78.3317Z",
  fill: "#263238"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M137.424 143.961L137.193 146.53C137.098 146.734 137.329 146.938 137.662 146.938H166.714C166.972 146.938 167.183 146.809 167.203 146.646L167.462 144.076C167.462 143.899 167.251 143.75 166.972 143.75H137.893C137.803 143.742 137.713 143.758 137.631 143.795C137.549 143.831 137.478 143.889 137.424 143.961Z",
  fill: "#407BFF"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M141.333 147.217H140.551C140.395 147.217 140.279 147.135 140.286 147.04L140.653 143.696C140.653 143.6 140.803 143.519 140.959 143.519H141.713C141.87 143.519 141.985 143.6 141.978 143.696L141.611 147.04C141.618 147.135 141.482 147.217 141.333 147.217Z",
  fill: "#263238"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M164.525 147.217H163.743C163.587 147.217 163.472 147.135 163.478 147.04L163.845 143.696C163.845 143.6 163.995 143.519 164.151 143.519H164.926C165.082 143.519 165.198 143.6 165.191 143.696L164.824 147.04C164.824 147.135 164.675 147.217 164.525 147.217Z",
  fill: "#263238"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M152.929 147.217H152.147C151.991 147.217 151.875 147.135 151.882 147.04L152.249 143.696C152.249 143.6 152.399 143.519 152.555 143.519H153.33C153.486 143.519 153.602 143.6 153.595 143.696L153.228 147.04C153.214 147.135 153.085 147.217 152.929 147.217Z",
  fill: "#263238"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M132.768 102.768C129.886 103.645 126.433 113.549 126.433 113.549L135.711 122.61C135.711 122.61 141.666 113.263 140.469 109.545C139.198 105.671 136.051 101.776 132.768 102.768Z",
  fill: "#407BFF"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M132.768 102.768C129.886 103.645 126.433 113.549 126.433 113.549L135.711 122.61C135.711 122.61 141.666 113.263 140.469 109.545C139.198 105.671 136.051 101.776 132.768 102.768Z",
  fill: "white"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M286.946 138.584H232.866V243.774H286.946V138.584Z",
  fill: "#407BFF"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M286.946 138.584H232.866V243.774H286.946V138.584Z",
  fill: "white"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M182.178 138.584H128.098V243.774H182.178V138.584Z",
  fill: "#407BFF"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M182.178 138.584H128.098V243.774H182.178V138.584Z",
  fill: "white"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M288.972 138.584H284.513V243.774H288.972V138.584Z",
  fill: "#407BFF"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M288.972 138.584H284.513V243.774H288.972V138.584Z",
  fill: "black"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M182.824 146.476H290.352V138.584H182.824V146.476Z",
  fill: "#407BFF"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M182.824 146.476H290.352V138.584H182.824V146.476Z",
  fill: "black"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M184.211 138.584H179.751V243.774H184.211V138.584Z",
  fill: "#407BFF"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M184.211 138.584H179.751V243.774H184.211V138.584Z",
  fill: "black"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M182.565 163.748H286.742V141.024H182.565V163.748Z",
  fill: "#407BFF"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M182.565 163.748H286.742V141.024H182.565V163.748Z",
  fill: "black"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M286.974 246.832H256.949C254.911 246.831 252.957 246.02 251.515 244.579C250.074 243.137 249.263 241.183 249.262 239.145V144.416C249.262 142.613 248.545 140.884 247.271 139.61C245.996 138.335 244.267 137.619 242.464 137.619H233.478V136.939H242.457C244.44 136.939 246.342 137.727 247.745 139.129C249.147 140.531 249.935 142.433 249.935 144.416V239.145C249.936 241.003 250.675 242.784 251.989 244.098C253.303 245.412 255.085 246.151 256.943 246.153H286.974C287.485 246.154 287.983 245.993 288.397 245.694C288.812 245.395 289.122 244.973 289.282 244.488C289.443 244.003 289.446 243.479 289.291 242.992C289.137 242.505 288.832 242.079 288.421 241.775L288.822 241.231C289.347 241.621 289.735 242.165 289.933 242.788C290.13 243.411 290.126 244.08 289.921 244.7C289.716 245.32 289.321 245.86 288.792 246.243C288.263 246.626 287.627 246.832 286.974 246.832Z",
  fill: "#407BFF"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M286.974 246.832H256.949C254.911 246.831 252.957 246.02 251.515 244.579C250.074 243.137 249.263 241.183 249.262 239.145V144.416C249.262 142.613 248.545 140.884 247.271 139.61C245.996 138.335 244.267 137.619 242.464 137.619H233.478V136.939H242.457C244.44 136.939 246.342 137.727 247.745 139.129C249.147 140.531 249.935 142.433 249.935 144.416V239.145C249.936 241.003 250.675 242.784 251.989 244.098C253.303 245.412 255.085 246.151 256.943 246.153H286.974C287.485 246.154 287.983 245.993 288.397 245.694C288.812 245.395 289.122 244.973 289.282 244.488C289.443 244.003 289.446 243.479 289.291 242.992C289.137 242.505 288.832 242.079 288.421 241.775L288.822 241.231C289.347 241.621 289.735 242.165 289.933 242.788C290.13 243.411 290.126 244.08 289.921 244.7C289.716 245.32 289.321 245.86 288.792 246.243C288.263 246.626 287.627 246.832 286.974 246.832Z",
  fill: "black"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M291.351 169.621H290.671V182.76H291.351V169.621Z",
  fill: "#407BFF"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M291.351 169.621H290.671V182.76H291.351V169.621Z",
  fill: "black"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M291.351 161.865H290.671V165.318H291.351V161.865Z",
  fill: "#407BFF"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M291.351 161.865H290.671V165.318H291.351V161.865Z",
  fill: "black"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M241.566 107.18H191.171L183.87 136.939H234.259L241.566 107.18Z",
  fill: "#407BFF"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M241.566 107.18H191.171L183.87 136.939H234.259L241.566 107.18Z",
  fill: "white"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M185.413 136.939L185.209 138.584H165.436L165.639 136.939H185.413Z",
  fill: "#407BFF"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M185.413 136.939L185.209 138.584H165.436L165.639 136.939H185.413Z",
  fill: "white"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M235.809 136.939L235.605 138.584H185.209L185.413 136.939H235.809Z",
  fill: "#407BFF"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M235.809 136.939L235.605 138.584H185.209L185.413 136.939H235.809Z",
  fill: "black"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M243.116 107.18H192.72L185.42 136.939H235.809L243.116 107.18Z",
  fill: "#407BFF"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M243.116 107.18H192.72L185.42 136.939H235.809L243.116 107.18Z",
  fill: "black"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M262.577 131.086C262.577 131.086 255.161 118.3 265.425 108.125C265.425 108.125 268.11 109.878 268.069 112.203C268.028 114.528 265.194 115.153 265.799 117.111C266.404 119.069 269.089 121.006 267.328 122.63C265.567 124.255 267.614 125.696 267.491 127.681C267.369 129.666 262.577 131.086 262.577 131.086Z",
  fill: "#407BFF"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M263.141 132.256C263.141 132.256 266.145 117.784 253.176 111.374C253.176 111.374 251.177 113.882 251.959 116.132C252.741 118.382 255.616 118.022 255.657 120.081C255.698 122.141 253.767 124.806 255.949 125.791C258.131 126.777 256.629 128.796 257.384 130.645C258.138 132.494 263.141 132.256 263.141 132.256Z",
  fill: "#407BFF"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M263.141 132.256C263.141 132.256 266.145 117.784 253.176 111.374C253.176 111.374 251.177 113.882 251.959 116.132C252.741 118.382 255.616 118.022 255.657 120.081C255.698 122.141 253.767 124.806 255.949 125.791C258.131 126.777 256.629 128.796 257.384 130.645C258.138 132.494 263.141 132.256 263.141 132.256Z",
  fill: "black"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M251.776 129.047C251.776 129.047 252.027 138.563 261.483 138.563C270.938 138.563 271.182 129.047 271.182 129.047H251.776Z",
  fill: "#407BFF"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M251.776 129.047C251.776 129.047 252.027 138.563 261.483 138.563C270.938 138.563 271.182 129.047 271.182 129.047H251.776Z",
  fill: "black"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M188.313 77.1478L204.891 92.455L215.551 72.5683L209.143 73.6457L205.313 50.8671L190.892 53.2918L194.721 76.0704L188.313 77.1478Z",
  fill: "#407BFF"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  d: "M220.651 62.5779C220.651 57.5301 222.656 52.689 226.225 49.1197C229.795 45.5504 234.636 43.5452 239.684 43.5452V48.5005C237.836 48.4996 236.007 48.8627 234.3 49.5691C232.592 50.2754 231.041 51.3112 229.735 52.6173C228.428 53.9233 227.391 55.474 226.684 57.1807C225.977 58.8875 225.613 60.7168 225.613 62.5643L220.651 62.5779Z",
  fill: "#407BFF"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M220.651 62.5779H225.613C225.613 66.3096 227.095 69.8885 229.734 72.5273C232.373 75.166 235.952 76.6485 239.684 76.6485C242.153 76.653 244.578 76.0008 246.712 74.7588L249.2 79.0887C246.307 80.7592 243.024 81.6387 239.683 81.6386C236.342 81.6386 233.06 80.7591 230.167 79.0885C227.273 77.418 224.871 75.0152 223.2 72.1217C221.53 69.2283 220.651 65.9461 220.651 62.6051V62.5779Z",
  fill: "#407BFF"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M220.651 62.5779H225.613C225.613 66.3096 227.095 69.8885 229.734 72.5273C232.373 75.166 235.952 76.6485 239.684 76.6485C242.153 76.653 244.578 76.0008 246.712 74.7588L249.2 79.0887C246.307 80.7592 243.024 81.6387 239.683 81.6386C236.342 81.6386 233.06 80.7591 230.167 79.0885C227.273 77.418 224.871 75.0152 223.2 72.1217C221.53 69.2283 220.651 65.9461 220.651 62.6051V62.5779Z",
  fill: "white"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M239.683 48.5005V43.5316C243.886 43.5156 247.976 44.8913 251.316 47.4441C254.655 49.9969 257.055 53.5833 258.141 57.6436C259.228 61.7038 258.94 66.0096 257.323 69.889C255.705 73.7684 252.849 77.0033 249.199 79.0888L246.718 74.786C249.421 73.2475 251.537 70.8565 252.736 67.9872C253.936 65.1179 254.15 61.932 253.346 58.9279C252.542 55.9239 250.765 53.271 248.293 51.3843C245.821 49.4976 242.793 48.4835 239.683 48.5005Z",
  fill: "#407BFF"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M239.683 48.5005V43.5316C243.886 43.5156 247.976 44.8913 251.316 47.4441C254.655 49.9969 257.055 53.5833 258.141 57.6436C259.228 61.7038 258.94 66.0096 257.323 69.889C255.705 73.7684 252.849 77.0033 249.199 79.0888L246.718 74.786C249.421 73.2475 251.537 70.8565 252.736 67.9872C253.936 65.1179 254.15 61.932 253.346 58.9279C252.542 55.9239 250.765 53.271 248.293 51.3843C245.821 49.4976 242.793 48.4835 239.683 48.5005Z",
  fill: "black"
});

function SvgMainImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 253,
    viewBox: "0 0 340 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainImage);
export default __webpack_public_path__ + "static/media/main-image.46bcfde7.svg";
export { ForwardRef as ReactComponent };